import { alpha } from '@mui/material';
import { clamp } from '@ui/style/clamp-calculator';
import { between } from '@ui/style/style';
import { useResponsive } from '@ui/style/useResponsive';
import { bottomNavigation, headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const useRolesStyles = () => {
    const { isMobileIpadNavigation } = useResponsive();
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const statusHeight = 52.8;
    const spaceAfterStatus = 12;
    const containerEndPadding = 8;
    const spaceBelowTabs = 8;
    const cardContainerHeightDesktop = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight + spaceBelowHeading + pageEndPadding + statusHeight + spaceAfterStatus + containerEndPadding}px`;
    const cardContainerHeightMobile = `${headerHeight +
        spaceAboveHeader +
        headingHeight +
        spaceBelowTabs +
        containerEndPadding +
        bottomNavigation}px`;
    return {
        main: {
            display: 'flex',
            flexDirection: 'column',
            gap: isMobileIpadNavigation ? 1 : 4.25,
            pb: 1,
            overflowY: 'hidden',
            height: '100%',
            px: isMobileIpadNavigation ? 0 : clamp.calculate(8, 32)
        },
        mobileScreenHeader: {
            between,
            flexDirection: 'row',
            backgroundColor: (theme) => alpha(theme.palette.common.black, 0.2),
            px: clamp.calculate(8, 32),
            height: '100%',
            paddingBottom: 1
        },
        mobileScreenHeadingButton: {
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'row',
            alignItems: 'center'
        },
        roleContainer: {
            display: 'flex',
            flexDirection: 'column'
        },
        addNewUserHeading: {
            color: (theme) => theme.palette.common.white,
            fontWeight: 400
        },
        bottomRolesDrawer: {
            borderTopLeftRadius: 16,
            backgroundColor: (theme) => theme.palette.common.white92,
            backdropFilter: 'blur(20px)',
            borderTopRightRadius: 16
        }
    };
};
export default useRolesStyles;
